import createClient from "openapi-fetch";
export class ProductOpenerApiV3 {
    constructor(fetch, options) {
        this.fetch = fetch;
        this.baseUrl = options.host;
        this.client = createClient({
            fetch: this.fetch,
            baseUrl: this.baseUrl,
        });
    }
    async uploadProductImage(barcode, params) {
        return this.client.POST("/api/v3/product/{barcode}/images", {
            params: { path: { barcode } },
            body: Object.assign({}, params),
        });
    }
    /**
     * Deletes an uploaded image for a product
     * @param barcode - The barcode of the product corresponding to the image
     * @param imgid - The id of the image to be deleted
     * @returns A promise that resolves to the deletion response
     */
    async deleteProductImage(barcode, imgid) {
        return await this.client.DELETE("/api/v3/product/{barcode}/images/uploaded/{imgid}", { params: { path: { barcode, imgid } } });
    }
    /**
     * Returns product details by barcode with optional fields
     * @param barcode - The barcode of the product
     * @param query - An optional query object to filter the returned fields
     * @template T - An array of keys from ProductV3 to return
     * @example
     * ```typescript
     * const result = await api.getProductV3("1234567890123", { fields: ["product_name", "brands"] });
     * console.log(result.product.product_name, result.product.brands);
     * ```
     * @returns A promise that resolves to a product object with the specified fields or undefined if not found
     */
    async getProductV3(barcode, query) {
        var _a;
        const { error, data } = await this.client.GET("/api/v3/product/{barcode}", {
            params: {
                path: { barcode },
                query: Object.assign(Object.assign({}, query), { fields: (_a = query === null || query === void 0 ? void 0 : query.fields) === null || _a === void 0 ? void 0 : _a.join(",") }),
            },
        });
        if (error != null) {
            return { error, data: undefined };
        }
        return {
            data: data,
            error: undefined,
        };
    }
}
//# sourceMappingURL=off-v3.js.map